import {
    Authenticator,
    useTheme,
    Heading,
    Text,
    View,
    Image,
    Flex,
    TableBody,
    TableCell, 
    Table, 
    TableRow, 
    TableHead, 
} from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
// Issue #143 sub-step 6: SDK migration to Amplify v6.
// v5 exported `I18n` from the top-level `aws-amplify` entry; v6 moved it
// to the `aws-amplify/utils` subpath. No call-site changes -- same API.
import { I18n } from 'aws-amplify/utils';
import { translations } from '@aws-amplify/ui-react';

// first add the official set of translations available to i18n
I18n.putVocabularies(translations);

// create custom dictionary for japanese browsers that is 日英併記
I18n.putVocabulariesForLanguage('ja', {
    'Sign In': 'ログイン (Sign In)', // Tab header
    'Sign in': 'ログイン (Sign In)', // Button label
    'Sign in to your account': 'アカウントにログインする(Sign in to your account)',
    Username: 'メールアドレス (Email)*', // Username label
    Password: 'パスワード (Password)*', // Password label
    UsernamePlaceholder: 'メールアドレス (Email)', // Username placeholder
    PasswordPlaceholder: 'パスワード (Password)', // Password placeholder
    'Code': 'コード(Verification Code)',
    'Submit': '送信する（Submit）',
    'Sending': '送信中(Sending)',
    'Resend Code': 'コードを再送信する（Resend Verification Code）',
    'Forgot your password?': 'パスワードを再設定する (Reset Password)',
    'Reset Password': '新しいパスワードを設定する (Set New Password)',
    'User does not exist.': '入力されたメールアドレスに該当するユーザーが存在しません。 (User with the email address you entered does not exist.)',
    'Send code': '検証用コードをメールアドレスに送信する (Send Verification Code to email)',
    'Back to Sign In': 'ログイン画面に戻る (Back to Sign In Screen)',
    'Code *': '検証用コードを入力 (Verification Code)',
    'New Password': '新しいパスワードを入力 (New Password)',
    'Confirm Password': 'パスワードの再入力 (Confirm Password)',
    'Your passwords must match': '「新しいパスワード」 と 「新しいパスワード(再入力)」 が一致しません。(Your passwords must match)',
    'Incorrect username or password.': 'ユーザー名またはパスワードが違います (Incorrect username or password.)',
    'User is not confirmed.': 'ユーザーは検証されていません (User is not confirmed.)',
    'User already exists': 'ユーザーは既に存在します (User already exists)',
    'Invalid verification code provided, please try again.': '指定された確認コードが無効です。もう一度お試しください (Invalid verification code provided, please try again.)',
    'Invalid password format': 'パスワードのフォーマットが不正です (Invalid password format)',
    'Account recovery requires verified contact information': 'アカウントの復旧には確認済みの連絡先情報が必要です (Account recovery requires verified contact information)',
    'Invalid phone number format': '不正な電話番号フォーマットです。 電話番号は次のフォーマットで入力してください: +12345678900 (Invalid phone number format)',
    'An account with the given email already exists.': 'そのメールアドレスは既に存在します (An account with the given email already exists.)',
    'Username cannot be empty': 'ユーザー名は必須です (Username cannot be empty)',
    'Password attempts exceeded': 'ログイン試行回数が上限に達しました (Password attempts exceeded)',
    'Attempt limit exceeded, please try after some time.': '試行制限を超過しました。しばらくしてからもう一度お試しください (Attempt limit exceeded, please try after some time.)',
    'Username/client id combination not found.': '入力されたメールアドレスに該当するユーザーが存在しません (User with the email address you entered does not exist.)',
    'CUSTOM_AUTH is not enabled for the client.': 'パスワードは必須です (CUSTOM_AUTH is not enabled for the client.)', // 本来の意味とは異なるが、パスワード未入力時に発生するのでこの訳としている
    'Password does not conform to policy: Password not long enough': 'パスワードは10文字以上を入力してください (10文字以上の大文字小文字を含む英数字) (Password does not conform to policy: Password not long enough)', // 適宜修正
    'Password does not conform to policy: Password must have uppercase characters': 'パスワードには大文字を含めてください (10文字以上の大文字小文字を含む英数字) Password does not conform to policy: Password must have uppercase characters', // 適宜修正
    'Password does not conform to policy: Password must have lowercase characters': 'パスワードには小文字を含めてください (10文字以上の大文字小文字を含む英数字) Password does not conform to policy: Password must have lowercase characters', // 適宜修正
    'Password does not conform to policy: Password must have numeric characters': 'パスワードには数字を含めてください (10文字以上の大文字小文字を含む英数字) Password does not conform to policy: Password must have numeric characters', // 適宜修正
    "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6": "パスワードは10文字以上、大文字小文字を含む英数字を指定してください (1 validation error detected: Value at 'password' failed to satisfy constraint: Password must have length greater than or equal to 10)", // 適宜修正。本来の意味とは異なるがこれで明示している。
    "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$": "パスワードは10文字以上、大文字小文字を含む英数字を指定してください（1 validation error detected: Value at 'password' failed to satisfy constraint: Password must have length greater than or equal to 10 and must contain at least one uppercase letter, one lowercase letter and a number.）",
    "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6; Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$": "パスワードは10文字以上、大文字小文字を含む英数字を指定してください (2 validation errors detected: Value at 'password' failed to satisfy constraint: Password must have length greater than or equal to 10; Value at 'password' failed to satisfy constraint: Password must have length greater than or equal to 10)", // 適宜修正。本来の意味とは異なるがこれで明示している。
    'Temporary password has expired and must be reset by an administrator.': '一時パスワードは無効です。管理者によるリセットが必要です',
    "1 validation error detected: Value null at 'attributeName' failed to satisfy constraint: Member must not be null": "入力チェックエラー、必須項目がNULLです (1 validation error detected: Value null at 'attributeName' failed to satisfy constraint: Member must not be null)", //アカウント復旧でのメールアドレスのラジオをチェックONにせず、送信した場合
    'Invalid code received for user': '無効なコードです (Invalid code received for user)', // TOTPでのトークンに誤りがある
    'Invalid session for the user, session is expired.': '無効なセッション、セッションは有効期限切れです。ログインからやり直してください (Invalid session for the user, session is expired.)' // ログインセッション無効です、ログインからやり直し
});

// explicitly set lanuage to japanese to use the custom 日英併記 translation throughout this component. 
I18n.setLanguage('ja');

const SignInComponent = () => {
    const formFields = {
        signIn: {
            username: {
                label: I18n.get('Username'),
                placeholder: I18n.get('UsernamePlaceholder'),
                isRequired: true,
            },
            password: {
                label: I18n.get('Password'),
                placeholder: I18n.get('PasswordPlaceholder'),
                isRequired: true,
            },
        },

        resetPassword: {
            username: {
                label: I18n.get('Username'),
                placeholder: I18n.get('UsernamePlaceholder'),
                isRequired: true,
            }
        },

        confirmVerifyUser: {
            confirmation_code: {
                label: "New Label",
                placeholder: "Enter your Confirmation Code:",
                isRequired: false,
            },
        },
    };

    // you can customize these to change the look and content of each 'slots' of the authenticator
    const components = {
        Header() {
            const { tokens } = useTheme();

            return (
                <View>
                    <View textAlign="center" padding={tokens.space.large}>
                        <Image
                            alt="grew-bancroft logo"
                            src="https://grew-bancroft.or.jp/wp/wp-content/themes/grew/images/common/logo.png"
                        />
                    </View>
                    <Flex
                        padding={`0 0 ${tokens.space.xl} 0`}
                        direction="column"
                    >
                        <Heading
                            level={4}
                        >
                            調査書・推薦状アップローダー
                        </Heading>
                        <Heading
                            level={4}
                        >
                            School Report & Recommendation Letter Uploader
                        </Heading>
                    </Flex>
                </View>

            );
        },

        // #demo: a footer manual througout the authentication process to support teachers
        Footer() {
            const { tokens } = useTheme();

            return (
                <>
                
                <View width="100%" paddingTop={tokens.space.xl}>
                    <Table
                        caption=""
                        highlightOnHover={false}
                        variation="bordered"
                        width="100%"
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell as="th" fontSize="larger">本アップローダーの使い方</TableCell>
                                <TableCell as="th" fontSize="larger">How to use the Uploader</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>
                                    <Text>
                                    初めてログインされる方は、以下の手順に従ってください：
                                    </Text>
                                    <Text>
                                    1. このプラットフォームのリンクが届いたメールアドレスを入力してください。
                                    </Text>
                                    <Text>
                                    2. メールアドレスに送信された初期パスワードを入力してください。
                                    </Text>
                                    <Text>
                                    3. ログイン後、新しいパスワードを設定してください。
                                    </Text>
                                </TableCell>
                                <TableCell>
                                    <Text>
                                    Follow these steps to sign in for the first time:
                                    </Text>
                                    <Text>
                                    1. Enter the email address where you received the link to this platform.
                                    </Text>
                                    <Text>
                                    2. Provide the initial password that was sent to your email address.
                                    </Text>
                                    <Text>
                                    3. After signing in, you will be prompted to set a new password.
                                    </Text>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                <Text>
                                次回以降のサインインには、以下の手順に従ってください：
                                </Text>
                                    <Text>
                                    1. 初回のログイン時に使用した同じメールアドレスを入力してください。
                                    </Text>
                                    <Text>
                                    2. 初回のログイン時に登録したパスワードを入力してください。
                                    </Text>
                                </TableCell>
                                <TableCell>
                                    <Text>
                                    For all subsequent sign-ins, please follow these steps:
                                    </Text>
                                    <Text>
                                    1. Use the same email address that you used during your initial sign-in.
                                    </Text>
                                    <Text>
                                    2. Enter the password that you registered during your first sign-in.
                                    </Text>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                <Text>
                                パスワードをリセットするには、以下の手順に従ってください：
                                </Text>
                                    <Text>
                                    1. ログインページで、「パスワードを再設定する」ボタンをクリックしてください。
                                    </Text>
                                    <Text>
                                    2. 次のページで、アカウントに紐づけられたメールアドレスを入力してください。
                                    </Text>
                                    <Text>
                                    3. 入力されたメールアドレスに検証用コードを含むメールが送信されます。(メールは最初の案内メールに似ていますが、初回パスワード部分に検証用コードが記されています。)
                                    </Text>
                                    <Text>
                                    4. メールから検証用コードを取得し、指定されたフィールドに入力してください。
                                    </Text>
                                    <Text>
                                    5. アカウントの新しいパスワードを設定してください。
                                    </Text>
                                    <Text>
                                    6. パスワードが正常に再設定されると、新しいパスワードを使用してログインできるようになります。
                                    </Text>
                                </TableCell>
                                <TableCell>
                                    <Text>
                                    To reset your password, please follow these steps:
                                    </Text>
                                    <Text>
                                    1. On the sign-in page, click on the "Reset password" button.
                                    </Text>
                                    <Text>
                                    2. You will be directed to enter the email address associated with your account.
                                    </Text>
                                    <Text>
                                    3. An email containing a Verification Code will be sent to the provided email address. (The email is similar to the first one, but the code is written on the "Temporary Password" part.)
                                    </Text>
                                    <Text>
                                    4. Retrieve the Verification Code from your email and enter it in the designated field.
                                    </Text>
                                    <Text>
                                    5. Set a new password for your account.
                                    </Text>
                                    <Text>
                                    6. Once your password is successfully reset, you will be able to sign in using your new password.
                                    </Text>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Text>
                                        推薦状・調査書の内容、締切日、様式などについては、出願者（生徒）本人が責任をもって担当者へお伝えいただくようお願いしております。
                                    </Text>
                                    <Text>
                                        【調査書・推薦状アップローダー】は、出願者本人が出願書類（ネット出願）に担当者を登録することで初めてご利用いただけます。ログイン情報を含む利用案内が届かない場合は、出願者へご連絡ください。
                                    </Text>
                                    <Text>
                                        学校の規則によりアップローダーを利用できない場合は、<a href="https://grew-bancroft.or.jp/description2/">基金ウェブサイト</a>をご参照ください。
                                    </Text>
                                </TableCell>
                                <TableCell>
                                    <Text>
                                        It is the applicant (student)'s responsibility to inform you of the contents, deadlines, formats, and other requirements related to letters of recommendation and academic transcripts.
                                    </Text>
                                    <Text>
                                        You will receive login information once the applicant registers the recommender's information as part of their online application. If you have not received the usage instructions, please contact the applicant directly. 
                                    </Text>
                                    <Text>
                                        If you are unable to use the uploader due to school regulations, please go to <a href="https://grew-bancroft.or.jp/description2/">our website</a>.
                                    </Text>
                                    <Text>
                                        Please note that if the automatic translation feature is enabled on your web browser, the applicant's name may be incorrectly spelled. Please use the English mode that you can toggle on the right corner of the portal for an accurate English spelling.
                                    </Text>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>        
                </View>
                <View width="100vw" paddingTop={tokens.space.xl}>
                    <br/>
                    <Text fontWeight="bold">お問い合わせ先</Text>
                    <Text>公益財団法人 グルー・バンクロフト基金</Text>
                    <Text>〒106-0047 東京都港区南麻布2-8-21 SNUG MINAMI-AZABU 301</Text>
                    <Text>電話・ファックス (03) 5443-1136</Text>
                    <Text>E-mail: apply@grew-bancroft.or.jp</Text>
                    <Text>※応募に関するご質問は、原則メールにてお願いします。</Text>
                    <br/>
                    <Text fontWeight="bold">Contact Information</Text>
                    <Text>The Grew Bancroft Foundation</Text>
                    <Text>SNUG MINAMI-AZABU 301, 2-8-21 Minami-Azabu, Minato-ku, Tokyo 106-0047</Text>
                    <Text>Phone/Fax: (03) 5443-1136</Text>
                    <Text>E-mail: apply@grew-bancroft.or.jp</Text>
                    <Text>*For inquiries regarding applications, please contact us by email.</Text>
                </View>
                </>
            );
        },

        VerifyUser: {
            Header() {
                const { tokens } = useTheme();
                return (
                    <Heading
                        padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
                        level={3}
                    >
                        Enter Information:
                    </Heading>
                );
            },
            Footer() {
                return <Text>Footer Information</Text>;
            },
        },

        ConfirmVerifyUser: {
            Header() {
                const { tokens } = useTheme();
                return (
                    <Heading
                        padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
                        level={3}
                    >
                        Enter Information:
                    </Heading>
                );
            },
            Footer() {
                return <Text>Footer Information</Text>;
            },
        },

        SignIn: {
            Header() {
                return (
                    <View
                    >
                    </View>
                );
            },


        }

    };


    return (
        <Authenticator
            formFields={formFields}
            components={components}
            hideSignUp={true}
        >
            {({ signOut, user }) => (
                <main>
                    <h1>グルー・バンクロフト基金 調査書・推薦状アップローダー</h1>
                    <button onClick={signOut}>Sign out</button>
                </main>
            )}
        </Authenticator>
    );
};

export default SignInComponent;